import classNames from 'classnames'
import { JSX } from 'react'

import { DatePicker } from 'core-components/library/datepicker'
import { IDatePicker } from 'core-components/library/datepicker/models/IDatePicker'
import { createComponentFn } from 'onboarding/components/helpers/createComponentFn'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn = (props: IDatePicker) => JSX.Element

const applyDisabled = (component: TComponentFn) => {
  return (props: IDatePicker) => {
    const { disabled, classes } = props
    const disabledTheme = disabled ? themesStyles.disabledDatePicker : undefined

    return component({
      ...props,
      classes: {
        ...classes,
        controlClasses: {
          ...classes?.controlClasses,
          root: classNames(classes?.controlClasses?.root, disabledTheme),
        },
      },
    })
  }
}

export const OnboardingDatePicker = (props: IDatePicker) =>
  applyDisabled(createComponentFn<IDatePicker & JSX.IntrinsicAttributes>(DatePicker))(props)
